import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=edc46f70&scoped=true&"
import script from "./contact-form.ts?vue&type=script&lang=ts&"
export * from "./contact-form.ts?vue&type=script&lang=ts&"
import style0 from "./contact-form.scss?vue&type=style&index=0&id=edc46f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc46f70",
  null
  
)

export default component.exports